import Login from './Login';

const Auth = {
  Login
}

export default Auth;